<template>
  <section :class="wrapperClasses" v-if="this.model.items && this.model.items.length" :id="`uuid-${model.uuid}`">
    <div class="section__container section__container--full-small">
      <div class="carousel-product">
        <div class="listing-header" :class="{'listing-no-title' : !model.listingTitle}">
          <div v-if="model.listingTitle">
            <h2
                class="listing-header__heading text--heading-l text--heading-l--section"
                v-if="model.listingTitle"
            >{{model.listingTitle}}
            </h2>
            <p class="listing-header__note" v-if="showNote">
              <msg id="common.price.tooltip.text"/>
            </p>
          </div>
          <div v-if="showViewAll" class="carousel-product__navigation">
            <pg-button
                :href="model.carousel.viewAllLink | mgnlLink('url') "
                styleType="text"
                size="medium"
                v-if="showViewAll"
                class="carousel-product__viewall"
            >
              <msg id="common.carousel.viewall.text"/>
            </pg-button>
          </div>
        </div>
        <div class="carousel">
          <div v-if="showArrows" class="carousel__arrows" :class="windowWidth ? 'carousel__arrows-zoom' : ''">
            <pg-button
                class="carousel__arrows__prev"
                :styleType="'icon'"
                :icon="'icon-arrow-sx'"
                :eventParams="{}"
                :eventName="`carousel-${model.uuid}:Prev`"
            >
              <msg id="common.carousel.previous.aria"/>
            </pg-button>
            <pg-button
                class="carousel__arrows__next"
                :styleType="'icon'"
                :icon="'icon-arrow-dx'"
                :eventParams="{}"
                :eventName="`carousel-${model.uuid}:Next`"
            >
              <msg id="common.carousel.next.aria"/>
            </pg-button>
          </div>
          <hooper :settings="hooperSettings" :class="hooperClasses" :ref="`carousel-${model.uuid}`">
            <hooper-slide v-for="item in model.items" :key="item.uuid" :index="item.uuid">
              <card-product
                :class="{'cursor-default': model.disableLinks === 'linksDisabled'}"
                :select="model.disableLinks === 'linksDisabled' ? 'linksDisabled' : ''"
                :item="item" :productCardConf="common.productCardConf" :priceFormatting="common.priceFormatting"/>
            </hooper-slide>
          </hooper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /**
   - Carousel Accessories / Vehicles
   **/

  import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
  import {Hooper, Slide as HooperSlide} from "hooper";
  import CardProduct from "../Card-Product/Card-Product";
  import PgButton from "../Button/Button";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
    name: "CarouselV1",
    components: {
      CardProduct,
      Hooper,
      HooperSlide,
      PgButton
    },
    data() {
      return {
        hooperSettings: {
          initialSlide: 0,
          itemsToShow: 1.5,
          itemsToSlide: 1,
          centerMode: true,
          wheelControl: false,
          infiniteScroll: false,
          touchDrag: true,
          mouseDrag: false,
          breakpoints: {
            640: {
              initialSlide: 0,
              itemsToShow: 4,
              itemsToSlide: 1,
              centerMode: false,
              touchDrag: false,
              mouseDrag: false,
              infiniteScroll: true
            },
            1024: {
              initialSlide: 0,
              itemsToShow: 4,
              itemsToSlide: 1,
              centerMode: false,
              touchDrag: false,
              mouseDrag: false,
              infiniteScroll: true
            }
          }
        },
        isPrevDisabled: false,
        isNextDisabled: false,
        itemsLessThanItemsToShow: {
          small: false,
          medium: false,
          large: false
        },
        windowWidth: false,
        isTabMobile: false
      };
    },
    mounted() {
      this.visualizationSettings();
    },
    updated() {
      this.visualizationSettings();
    },
    computed: {
      showArrows() {
        let itemsToShow;
        if (this.$mq === "small") {
          itemsToShow = this.hooperSettings.itemsToShow;
        } else {
          // ignoring medium not to show arrows for accessory on medium
          itemsToShow = this.hooperSettings.breakpoints[1024].itemsToShow;
        }
        let condition =
            this.model.carousel.arrows &&
            this.model.items &&
            this.model.items.length > itemsToShow;

        // PIAGGIO-8774: content visibility with zoom 400%
        // always displays arrows if desktop screen zoom is active
        if (!this.isTabMobile && this.windowWidth) {
          condition = true;
        } else if (this.$mq === "small" && this.model.listingType === "accessory") {
          condition = this.model.items && this.model.items.length >= 2;
        }

        return condition;
      },
      showViewAll() {
        if (this.model.disableLinks === 'linksDisabled') return false;
        return this.model.carousel.viewAllLink;
      },
      wrapperClasses() {
        let wrapperClass = "";

        if (this.model.listingType === "accessory" || this.model.listingType === "service") {
          wrapperClass = "tertiary-1-accessories";
        } else if (this.model.listingType === "vehicle") {
          wrapperClass = "tertiary-1";
        }

        return ["section", "section--" + wrapperClass];
      },

      hooperClasses() {
        return [
          this.itemsLessThanItemsToShow[this.$mq] ? "centered" : "",
          "hooper--partial-slide"
        ];
      },
      showNote() {
        return this.model.listingType === "vehicle" && this.common.priceNote;
      }
    },

    methods: {
      slidePrev() {
        setTimeout(() => {
          this.$refs[`carousel-${this.model.uuid}`].slidePrev();
        }, 10);
      },
      slideNext() {
        setTimeout(() => {
          this.$refs[`carousel-${this.model.uuid}`].slideNext();
        }, 10);
      },
      visualizationSettings() {
        this.$eventHub.on(`carousel-${this.model.uuid}:Prev`, () => {
          this.slidePrev();
        });
        this.$eventHub.on(`carousel-${this.model.uuid}:Next`, () => {
          this.slideNext();
        });

        if (this.model.listingType === "accessory" || this.model.listingType === "service") {
          this.hooperSettings.breakpoints[640].itemsToShow = 5;
          this.hooperSettings.breakpoints[1024].itemsToShow = 6;
        }

        // check if items are less than items to show,
        // in this case a set the carousel infinite to false
        // and apply a class to center the content
        // for each breakpoint

        if (
            this.model.items &&
            this.model.items.length > this.hooperSettings.itemsToShow
        ) {
          //small
          this.hooperSettings.infiniteScroll = true;
          //this.itemsLessThanItemsToShow["small"] = true;
        }
        if (
            this.model.items &&
            this.model.items.length < this.hooperSettings.breakpoints[640].itemsToShow
        ) {
          // medium
          this.hooperSettings.breakpoints[640].infiniteScroll = false;
          this.itemsLessThanItemsToShow["medium"] = true;
        }
        if (
            this.model.items &&
            this.model.items.length <
            this.hooperSettings.breakpoints[1024].itemsToShow
        ) {
          //large
          this.hooperSettings.breakpoints[1024].infiniteScroll = false;
          this.itemsLessThanItemsToShow["large"] = true;
        }

        this.isPrevDisabled = !this.hooperSettings.breakpoints[1024].infiniteScroll;

        // PIAGGIO-8774: content visibility with zoom 400%
        this.isTabMobile = window.screen.width <= 1023;
        this.windowWidth = window.visualViewport.width < 1010;
      }
    }
  };
</script>
